import { authHeaders, betterFetch, CCS_URL, turnFiltersIntoSearchObj } from './helper';

/**
 * get content by links
 * @param {string[]} links - array of links for which to search
 * @returns {Promise<Response>} the reponse object
 */
export const getContentByLinks = function getContentByLinks({ links }) {
  const headers = authHeaders();
  const params = links.map(link => `links=${encodeURIComponent(link)}`).join('&');
  const url = `${CCS_URL}/search/content-by-links?${params}`;
  return betterFetch(url, { headers });
};

/**
 * gets search suggestions from es
 * @param {string} context - the search context
 * @param {string} inputValue - the value of the input
 * @param {object[]} filters - an array existing of simple filter objects
 * @returns {Promise<Response>} the reponse object
 */
export const getSearchSuggestions = function getSearchSuggestions(
  context,
  inputValue,
  filters = []
) {
  const headers = authHeaders();
  const params = new URLSearchParams({
    context,
    filters: JSON.stringify(turnFiltersIntoSearchObj(filters)),
    search: inputValue
  });

  return betterFetch(`${CCS_URL}/search/suggestions?${params}`, { headers });
};

/**
 * gets search results from ElasticSearch
 * @param {string} context - the search context
 * @param {Array} filters - the value of the filters
 * @returns {Promise<Response>} the reponse object
 */
export const getSearchResults = function getSearchResults(context, filters = []) {
  const search = turnFiltersIntoSearchObj(filters);
  const headers = authHeaders();
  const payload = {
    context,
    search,
    size: 1000
  };
  const options = {
    headers,
    body: JSON.stringify(payload),
    method: 'POST'
  };

  return betterFetch(`${CCS_URL}/search/results`, options);
};

/**
 * gets most recently created component from es
 * @param {string} lanId - lanId of the user
 * @param {string} count - count of components to get
 * @returns {Promise<Response>} the reponse object
 */
export const getMostRecentComponents = function getMostRecentComponents(lanId, count) {
  const headers = authHeaders();
  const payload = {
    context: 'components',
    search: { Tags: [lanId] },
    size: count,
    sort: [{ DateModified: 'desc' }]
  };
  const options = {
    headers,
    body: JSON.stringify(payload),
    method: 'POST'
  };
  return betterFetch(`${CCS_URL}/search/results`, options);
};
